import React from 'react';
import CalOptions from './CalOptions';
import { getDatabase, ref, set as FirebaseSet, onValue, push as FirebasePush , get} from 'firebase/database';
import _ from 'lodash';
import { dataProcess } from './DataProcess';


export default function Schedule(props) {

    var selectedCourse = props.selectedCourse;
    var setPlan = props.setPlan;
    var currPlan = props.currPlan;
    var plans = props.plans;
    var setCourse = props.setCourse;
    const allSearchData = require('./data/search.json');

    // const db = getDatabase();
    
    // const allSearchData = {"INFO 340" : {"code": "INFO 340", "name": "Client-Side Development", "credit": [5], "type": "qsr", "info": "Introduction to client-side development on the internet, including markup, programming languages, protocols, libraries, and frameworks for creating and maintaining usable and accessible, interactive applications.\n\nPrerequisite:\nEither CSE 143, CSE 154, or CSE 163\nINFO 201.", "timeInfo": [{"Lec": {"A": ["Tue-0830-110", "Thu-0830-110"]}, "Sec": [{"AA": ["Wed-1530-50"]}, {"AB": ["Tue-1630-50"]}]},{"Lec": {"B": ["Tue-1730-110", "Thu-1730-110"]}, "Sec": [{"BA": ["Wed-1530-50"]}, {"BB": ["Wed-1630-50"]}]}]},
    // "M E 123": {"code": "M E 123", "name": "Introduction To Visualization And Computer-Aided Design", "credit": [4], "type": "vlpa or nw", "info": "Methods of depicting three-dimensional objects and communicating design information. Development of three-dimensional skills through freehand sketching and computer-aided design using parametric solid modeling. Instructors: Adee\n\nPrerequisite:\nNone", "timeInfo": [{"Lec": {"A": ["Mon-1230-50", "Wed-1230-50"]}, "Sec": [{"AA": ["Tue-0830-50", "Thu-0830-50"]},{"AB": ["Tue-0930-50", "Thu-0930-50"]},{"AC": ["Tue-1030-50", "Thu-1030-50"]},{"AD": ["Tue-1130-50", "Thu-1130-50"]},{"AE": ["Tue-1230-50", "Thu-1230-50"]},{"AF": ["Tue-1330-50", "Thu-1330-50"]},{"AG": ["Tue-1430-50", "Thu-1430-50"]}]},
    // {"Lec": {"B": ["Mon-1230-50", "Wed-1230-50"]}, "Sec": [{"BA": ["Tue-0830-50", "Thu-0830-50"]},{"BB": ["Tue-0930-50", "Thu-0930-50"]},{"BC": ["Tue-1030-50", "Thu-1030-50"]},{"BD": ["Tue-1130-50", "Thu-1130-50"]},{"BE": ["Tue-1230-50", "Thu-1230-50"]},{"BF": ["Tue-1330-50", "Thu-1330-50"]},{"BG": ["Tue-1430-50", "Thu-1430-50"]}]}]},
    // "HCDE 318": {"code": "HCDE 318", "name": "Introduction To User-Centered Design", "credit": [5], "type": "", "info": "Explores the user-centered design paradigm from a broad perspective, with an emphasis on the importance of developing and applying design processes and strategies. Students learn to think like a user-centered designer and carry out activities that are key to user-centered design.", "timeInfo": [{"Lec": {"A": ["Mon-1500-140", "Wed-1500-140"]}, "Sec": []},{"Lec": {"B": ["Tue-0930-140", "Thu-0930-140"]}, "Sec": []}]}
    // }

    // const allSearchData2 = {"INFO 340" : {"code": "INFO 340", "name": "Client-Side Development", "credit": [5], "type": "qsr", "info": "Introduction to client-side development on the internet, including markup, programming languages, protocols, libraries, and frameworks for creating and maintaining usable and accessible, interactive applications.\n\nPrerequisite:\nEither CSE 143, CSE 154, or CSE 163\nINFO 201.", 
    //                     "section" :[
    //                         {"name": "A", "type": "Lecture", "time": ["Tue-1030-110", "Thu-1030-110"], "location": "BAG 260", "instructor": "Joel Ross", "SLN": 16825},
    //                         {"name": "AA", "type": "Laboratory", "time": ["Wed-1130-50"], "location": "MGH 334", "instructor": "", "SLN": 16826},
    //                         {"name": "AB", "type": "Laboratory", "time": ["Thu-0930-50"], "location": "MGH 334", "instructor": "", "SLN": 16827},
    //                         {"name": "B", "type": "Lecture", "time": ["Tue-1330-110", "Thu-1330-110"], "location": "EGL 001", "instructor": "Joel Ross", "SLN": 16828},
    //                         {"name": "BA", "type": "Laboratory", "time": ["Wed-1330-50"], "location": "MGH 430", "instructor": "", "SLN": 16829},
    //                         {"name": "BB", "type": "Laboratory", "time": ["Thu-1130-50"], "location": "MGH 334", "instructor": "", "SLN": 16829}
    //                         ]}
    //                 ,
    //                 "M E 123": {"code": "M E 123", "name": "Introduction To Visualization And Computer-Aided Design", "credit": [4], "type": "vlpa or nw", "info": "Methods of depicting three-dimensional objects and communicating design information. Development of three-dimensional skills through freehand sketching and computer-aided design using parametric solid modeling. Instructors: Adee\n\nPrerequisite:\nNone",
    //                     "section": [
    //                         {"name": "A", "type": "Lecture", "time": ["Mon-1230-50", "Wed-1230-50"], "location": "ARC 147", "instructor": "Julia H Jones", "SLN": 17907},
    //                         {"name": "AA", "type": "Laboratory", "time": ["Tue-0830-50", "Thu-0830-50"], "location": "MEB 231", "instructor": "", "SLN": 17908},
    //                         {"name": "AB", "type": "Laboratory", "time": ["Tue-0930-50", "Thu-0930-50"], "location": "MEB 231", "instructor": "", "SLN": 17909},
    //                         {"name": "AC", "type": "Laboratory", "time": ["Tue-1030-50", "Thu-1030-50"], "location": "MEB 231", "instructor": "", "SLN": 17910},
    //                         {"name": "AD", "type": "Laboratory", "time": ["Tue-1130-50", "Thu-1130-50"], "location": "MEB 231", "instructor": "", "SLN": 17911},
    //                         {"name": "AE", "type": "Laboratory", "time": ["Tue-1230-50", "Thu-1230-50"], "location": "MEB 231", "instructor": "", "SLN": 17912},
    //                         {"name": "AF", "type": "Laboratory", "time": ["Tue-1330-50", "Thu-1330-50"], "location": "MEB 231", "instructor": "", "SLN": 17913},
    //                         {"name": "AG", "type": "Laboratory", "time": ["Tue-1430-50", "Thu-1430-50"], "location": "MEB 231", "instructor": "", "SLN": 17914},
    //                         {"name": "B", "type": "Lecture", "time": ["Mon-1230-50", "Wed-1230-50"], "location": "ARC 147", "instructor": "Julia H Jones", "SLN": 17915},
    //                         {"name": "BA", "type": "Laboratory", "time": ["Tue-0830-50", "Thu-0830-50"], "location": "MEB 231", "instructor": "", "SLN": 17916},
    //                         {"name": "BB", "type": "Laboratory", "time": ["Tue-0930-50", "Thu-0930-50"], "location": "MEB 231", "instructor": "", "SLN": 17917},
    //                         {"name": "BC", "type": "Laboratory", "time": ["Tue-1030-50", "Thu-1030-50"], "location": "MEB 231", "instructor": "", "SLN": 17918},
    //                         {"name": "BD", "type": "Laboratory", "time": ["Tue-1130-50", "Thu-1130-50"], "location": "MEB 231", "instructor": "", "SLN": 17919},
    //                         {"name": "BE", "type": "Laboratory", "time": ["Tue-1230-50", "Thu-1230-50"], "location": "MEB 231", "instructor": "", "SLN": 17920},
    //                         {"name": "BF", "type": "Laboratory", "time": ["Tue-1330-50", "Thu-1330-50"], "location": "MEB 231", "instructor": "", "SLN": 17921},
    //                         {"name": "BG", "type": "Laboratory", "time": ["Tue-1430-50", "Thu-1430-50"], "location": "MEB 231", "instructor": "", "SLN": 17922}
    //                     ]}
    //                 ,
    //                 "HCDE 318": {"code": "HCDE 318", "name": "Introduction To User-Centered Design", "credit": [5], "type": "", "info": "Explores the user-centered design paradigm from a broad perspective, with an emphasis on the importance of developing and applying design processes and strategies. Students learn to think like a user-centered designer and carry out activities that are key to user-centered design.",
    //                     "section": [
    //                         {"name": "A", "type": "Lecture", "time": ["Mon-1500-140", "Wed-1500-140"], "location": "SIG 233", "instructor": "", "SLN": 16229}
    //                     ]}
    //                 };
    
    // console.log("allSearchData2", allSearchData2);
    //insert course process code here
    
    var classInfo = [];

    classInfo = selectedCourse.map((singleCourse) => {
        var code = Object.keys(singleCourse)[0];
        var singleInfo = {};
        singleInfo[code] = dataProcess(allSearchData[code])["timeInfo"];
        return singleInfo
    });

    var timeAry = [];
    selectedCourse.map(singleSelectedClass => {
        renderSingleCourse(singleSelectedClass, classInfo, timeAry);
    });
    
    return (
        <div className="mainfunc-block">
            <div className="sidebar-view">
                <Calendar timeAry={timeAry}/>
                <CalOptions classInfo={classInfo} selectedCourse={selectedCourse} setCourse={setCourse} setPlan={setPlan} currPlan={currPlan} plans={plans} />
            </div>
        </div>
    )
}

class TableHeader extends React.Component {
    render() {
        const header = this.props.columnNames.map((str, index) => {
            return (
                <th key={index + 1}>
                    {str}
                </th>
            );
        });

        return (
            <thead>
                <tr>
                    <th key={0} className="cal-time"></th>
                    {header}
                </tr>
            </thead>
        );
    }
}

function transTime(time, mid=":") {
    var minuteStr = "00";
    if (time % 1.0 === 0.5) {
        minuteStr = "30";
    }
    var hourStr = ("0" + Math.floor(time)).slice(-2);
    return hourStr + mid + minuteStr;
}

function CalRow(props) {
    var result;
    if (props.time % 1 === 0.5) {
        result = "";
    }
    else {
        result = transTime(props.time);
    }
    var time = transTime(props.time, "");
    return (
        <tr id={"cal-" + time}>
            <th scope="row" className="cal-time">{result}</th>
            <td><RenderClass date={"Mon"} time={time} timeAry={props.timeAry} /></td>
            <td><RenderClass date={"Tue"} time={time} timeAry={props.timeAry} /></td>
            <td><RenderClass date={"Wed"} time={time} timeAry={props.timeAry} /></td>
            <td><RenderClass date={"Thu"} time={time} timeAry={props.timeAry} /></td>
            <td><RenderClass date={"Fri"} time={time} timeAry={props.timeAry} /></td>
        </tr>
    );
}

class Calendar extends React.Component {
    render() {
        const colName = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
        var allCalRow = [];
        var timeAry = this.props.timeAry;
        timeAry.sort((a, b) => {
            var time_a = parseInt(Object.keys(a)[0].substring(9, Object.keys(a)[0].length));
            var time_b = parseInt(Object.keys(b)[0].substring(9, Object.keys(b)[0].length));
            return (time_a < time_b) ? 1 : -1;
        });

        for (var i = 8; i <= 20; i += 0.5) {
            allCalRow.push(<CalRow id={"cal-" + i} key={i} time={i} timeAry={timeAry}/>)
        }
    
        return (
        <div className='calendar'>
          <table className='table table-bordered'>
            <TableHeader columnNames={colName} />
            <tbody id='cal-tb'>
                <tr className="spacer">
                    <th scope="row"></th>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>

                {allCalRow}
            </tbody>
          </table>
          </div>
        );
    }
}

function renderSingleCourse(singleSelectedClass, allClassTime, resultAry) {
    // render all LS
    var classCode = Object.keys(singleSelectedClass)[0]; //INFO 340
    var targetClassTime = allClassTime.filter(singleClass => Object.keys(singleClass)[0] === classCode)[0];
    targetClassTime[classCode].map(LSPair => {
        //Obj
        Object.values(LSPair).map(classInfo => {
            //classInfo: {"B": ["Tue-1730-110", "Thu-1730-110"]}

            if (!Array.isArray(classInfo)) {
                classInfo = [classInfo];
            }
            
            classInfo.forEach(singleInfo => {
                var lsCode = Object.keys(singleInfo)[0];
                if(singleSelectedClass[classCode].includes(lsCode)) {
                    //render this
                    var timeInfo = singleInfo[lsCode];
                    resultAry = transferSingleLS(classCode, lsCode, timeInfo, resultAry);
                }
            });

        })
    });
    return resultAry;
    
}

function transferSingleLS(classCode, lsCode, timeInfo, resultAry) {
    //INFO 340, B, ["Tue-1730-110", "Thu-1730-110"]
    timeInfo.forEach(time => {
        var resultObj = {[time]: [classCode, lsCode]};
        resultAry.push(resultObj);
    });
    return resultAry;
}

class RenderClass extends React.Component {
    render() {
        var elem = [];
        var date = this.props.date;
        var time = this.props.time;
        var timeAry = this.props.timeAry;


        timeAry.forEach((singleTime, i) => {
            var timeStr = date + "-" + time;
            var storedTimeStr = Object.keys(singleTime)[0];
            if (timeStr === storedTimeStr.substring(0, 8)) {
                var courseInfo = singleTime[storedTimeStr];
                var hashCode = (fakeHash(courseInfo[0]) % 5);
                var cssClass = "test-class t" + (storedTimeStr.substring(9, storedTimeStr.length)) + " color-" + hashCode;
                elem.push(
                    <div className={cssClass} key={i}>
                        <div className="class-title">{courseInfo[0]}</div>
                        <div className="class-section">{courseInfo[1]}</div>
                    </div>
                );
            }
        });
        if (elem.length === 0) {
            elem.push(<div key={0}></div>)
        }
        return (elem);
    }
}

function fakeHash(inputStr) {
    var hash = 0;
    for (var i = 0; i < inputStr.length; i++) {
        hash = hash * 31 + inputStr.charCodeAt(i);
    }
    return hash;
}